<div class="wrapper">
  <ng-content></ng-content>
</div>
